import { action } from 'satcheljs';

/**
 * Set selection state on the given row
 * @param rowKey the rowKey of the item to toggle selection on
 * @param tableViewId of the table where the selection took place
 * @param shouldSelect - whether the row should be selected or deselected
 */
export interface SET_SELECTION_ON_ROWActionMessage {
    rowKey: string;
    tableViewId: string;
    shouldSelect: boolean;
}
export const setSelectionOnRow: (
    rowKey: string,
    tableViewId: string,
    shouldSelect: boolean
) => SET_SELECTION_ON_ROWActionMessage = action(
    'SET_SELECTION_ON_ROW',
    (
        rowKey: string,
        tableViewId: string,
        shouldSelect: boolean
    ): SET_SELECTION_ON_ROWActionMessage => {
        return {
            rowKey,
            tableViewId,
            shouldSelect,
        };
    }
);
